//#region src/bite_log_printer_event.ts
var BiteLogPrinterEvent = /* @__PURE__ */ function(BiteLogPrinterEvent) {
	BiteLogPrinterEvent[BiteLogPrinterEvent["OK"] = 0] = "OK";
	BiteLogPrinterEvent[BiteLogPrinterEvent["ConnectError"] = 1] = "ConnectError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["ConnectTimeout"] = 2] = "ConnectTimeout";
	BiteLogPrinterEvent[BiteLogPrinterEvent["Disconnected"] = 3] = "Disconnected";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PowerOff"] = 4] = "PowerOff";
	BiteLogPrinterEvent[BiteLogPrinterEvent["AddCommandsError"] = 5] = "AddCommandsError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["SendError"] = 6] = "SendError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PrintJobFail"] = 7] = "PrintJobFail";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PrintJobTimeout"] = 8] = "PrintJobTimeout";
	BiteLogPrinterEvent[BiteLogPrinterEvent["CoverOpen"] = 9] = "CoverOpen";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PaperLow"] = 10] = "PaperLow";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PaperEmpty"] = 11] = "PaperEmpty";
	BiteLogPrinterEvent[BiteLogPrinterEvent["DiscoveryStartError"] = 14] = "DiscoveryStartError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["CoverClosed"] = 15] = "CoverClosed";
	BiteLogPrinterEvent[BiteLogPrinterEvent["ScannerConnectError"] = 16] = "ScannerConnectError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["ScannerDisconnected"] = 17] = "ScannerDisconnected";
	BiteLogPrinterEvent[BiteLogPrinterEvent["ScaleConnectError"] = 18] = "ScaleConnectError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["ScaleDisconnected"] = 19] = "ScaleDisconnected";
	BiteLogPrinterEvent[BiteLogPrinterEvent["QueueEnterFail"] = 20] = "QueueEnterFail";
	BiteLogPrinterEvent[BiteLogPrinterEvent["QueueCheckFail"] = 21] = "QueueCheckFail";
	BiteLogPrinterEvent[BiteLogPrinterEvent["QueueingDisabled"] = 22] = "QueueingDisabled";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PrintJobRequested"] = 23] = "PrintJobRequested";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PrintJobSucceed"] = 24] = "PrintJobSucceed";
	BiteLogPrinterEvent[BiteLogPrinterEvent["PaperOK"] = 25] = "PaperOK";
	BiteLogPrinterEvent[BiteLogPrinterEvent["CutterError"] = 26] = "CutterError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["MechanicalError"] = 27] = "MechanicalError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["AutoRecoverError"] = 28] = "AutoRecoverError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["UnrecoverableError"] = 29] = "UnrecoverableError";
	BiteLogPrinterEvent[BiteLogPrinterEvent["RecoverableError"] = 30] = "RecoverableError";
	return BiteLogPrinterEvent;
}(BiteLogPrinterEvent || {});
//#endregion
export { BiteLogPrinterEvent };

//# sourceMappingURL=bite_log_printer_event.js.map